import { BasicsTab } from "./BasicsTab";
import { ShiftTab } from "./ShiftTab";
import { HolidaysTab } from "./HolidaysTab";
import { PayrollTab } from "./PayrollTab";
import { AdvanceTab } from "./AdvanceTab";
import { LeaveTab } from "./LeaveTab";
import { ContactTab } from "./ContactTab";
import { LegalTab } from "./LegalTab";
import { QrTab } from "./QrTab";
import { AccountingTab } from "./AccountingTab";

export const BRANCH_TABS = [
  "basics", "accounting", "shift", "holidays", "payroll", "advances", "leave",
  "qr", "contact", "legal",
];

// لوحة التبويب الواحدة — تُبعد شجرة الشروط عن BranchForm وتحافظ على حد 100 سطر.
export const TabPanel = ({ tab, props, company, branchId, onLocate, onPickLocation }) => {
  if (tab === "basics") return <BasicsTab {...props} onLocate={onLocate} onPickLocation={onPickLocation} />;
  if (tab === "accounting") return <AccountingTab {...props} />;
  if (tab === "shift") return <ShiftTab {...props} attendancePolicy={company?.attendance_policy} />;
  if (tab === "holidays") return <HolidaysTab {...props} />;
  if (tab === "payroll") return <PayrollTab {...props} />;
  if (tab === "advances") return <AdvanceTab {...props} />;
  if (tab === "leave") return <LeaveTab {...props} companyPolicy={company?.leave_policy} />;
  if (tab === "qr") return <QrTab {...props} branchId={branchId} />
  if (tab === "contact") return <ContactTab {...props} />;
  if (tab === "legal") return <LegalTab {...props} />;
  return null;
};
